import axios from 'axios'

import { apiUrlEnvUtils } from '../../utils/api-url-env.utils'

const SHOWROOM_API_URL = apiUrlEnvUtils('REACT_APP_SHOWROOM_API_URL')
// const SHOWROOM_API_URL = 'https://int-api.showroom360.ca:8443/service/v1' //only for local work (don't push)

/**
 * Generator JWT
 * @return {Promise<{}>}
 */
export const getJwt = async () => {
    return await axios.get(`${SHOWROOM_API_URL}/jwt?userName=public&password=public`)
}

/**
 * Get Showroom Payment Options
 * @param { Object } object - The default payload
 * @param { String } object.quoteId - QuoteId
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { Object } object.payload - Payload
 * @param { String } object.token - Token
 * @returns {Promise<{}>}
 */
export const getQuoteDeskingPaymentOptions = async ({ quoteId, lang, location, orgId, orgUnitId, payload, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/quote/desking/paymentOptions/${quoteId}?lang=${lang}&location=${location}&orgId=${orgId}&orgUnitId=${orgUnitId}&module=2&includeMeta=true`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.post(apiUrl, payload, headers)
}

/**
 * Get Showroom Payment Roll
 * @param { Object } object - The default payload
 * @param { String } object.quoteId - QuoteId
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { Object } object.payload - Payload
 * @param { String } object.token - The token identifier
 * @returns {Promise<{}>}
 */
export const getQuoteDeskingPaymentRoll = async ({ quoteId, lang, location, orgId, orgUnitId, payload, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/quote/desking/paymentRoll/${quoteId}?lang=${lang}&location=${location}&orgId=${orgId}&orgUnitId=${orgUnitId}&module=2`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.post(apiUrl, payload, headers)
}

/**
 * Get Quotes Summaries
 * @param { Object } object - The default payload
 * @param { String | Number } object.accountId - Account Id
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { String } object.token - The token identifier
 * @returns {Promise<{}>}
 */
export const getQuoteSummaries = async ({ accountId, lang, location, orgId, orgUnitId, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/quote/summaries/${accountId}?language=${lang}&location=${location}&orgId=${orgId}&orgUnitId=${orgUnitId}&ignoreDeleted=true&module=2`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.get(apiUrl, headers)
}

/**
 * Get Quote Desking
 * @param { Object } object - The default payload
 * @param { String } object.quoteId - Quote Id
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { String } object.token - The token identifier
 * @returns {Promise<{}>}
 */
export const getQuoteDesking = async ({ quoteId, lang, location, orgId, orgUnitId, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/quote/desking/${quoteId}?language=${lang}&location=${location}&orgId=${orgId}&orgUnitId=${orgUnitId}&includeMeta=true&module=2`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.get(apiUrl, headers)
}

/**
 * Put or Create Showroom quoteId for inventory listing used
 * @param { Object } object - The default payload
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { Object } object.payload - Payload
 * @param { String } object.token - The token identifier
 * @returns {Promise<{}>}
 */
export const putQuoteVehicleListingUsed = async ({ lang, location, orgId, orgUnitId, payload, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/quote/vehicle/listingUsed?orgId=${orgId}&orgUnitId=${orgUnitId}&location=${location}&lang=${lang}&priceIncreaseRollCount=0&module=2`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.put(apiUrl, payload, headers)
}

/**
 * Put or Create Showroom quoteId for inventory listing new
 * @param { Object } object - The default payload
 * @param { String } object.showroomVehicleId - Showroom VehicleId
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { Object } object.payload - Payload
 * @param { String } object.token - The token identifier
 * @returns {Promise<{}>}
 */
export const putQuoteVehicleListingNew = async ({ showroomVehicleId, lang, location, orgId, orgUnitId, payload, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/quote/vehicle/listingNew/${showroomVehicleId}?orgId=${orgId}&orgUnitId=${orgUnitId}&location=${location}&lang=${lang}&priceIncreaseRollCount=0&module=2`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.put(apiUrl, payload, headers)
}

/**
 * Put or Create Showroom quoteId for Catalog
 * @param { Object } object - The default payload
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { Object } object.payload - Payload
 * @param { String } object.token - The token identifier
 * @returns {Promise<{}>}
 */
export const putQuoteVehicleCatalog = async ({ lang, location, orgId, orgUnitId, payload, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/quote/vehicle/catalog?orgId=${orgId}&orgUnitId=${orgUnitId}&location=${location}&lang=${lang}&priceIncreaseRollCount=0&module=2`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.put(apiUrl, payload, headers)
}

/**
 * POST Catalog Payment Options
 * @param { Object } object - The default payload
 * @param { String } object.lang - Lang
 * @param { String } object.location - Location province
 * @param { String | Number } object.orgId - Organization Id
 * @param { String | Number } object.orgUnitId - Organization Unit Id
 * @param { Object } object.payload - Payload
 * @param { String } object.token - The token identifier
 * @returns {Promise<{}>}
 */
export const postCatalogNewPaymentOptions = async ({ lang, location, orgId, orgUnitId, payload, token }) => {
    const apiUrl = `${SHOWROOM_API_URL}/catalog/new/paymentOptions?location=${location}&orgId=${orgId}&orgUnitId=${orgUnitId}&lang=${lang}&includeMeta=true&priceIncreaseRollCount=0&module=2`

    const headers = {
        headers: {
            'accept-language': `${lang}-CA`,
            'Content-Type': 'application/json',
            'x-jwt': token,
        },
    }

    return await axios.post(apiUrl, payload, headers)
}
